import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';

type Props = {
    id: string;
    label: string;
    value: string;
    disabled?: boolean;
    multiline?: boolean;
    onSave: (value: string) => void;
};

export const SettingsTextInput = ({ id, label, value: savedValue, disabled = false, multiline = false, onSave }: Props) => {
    const [value, setValue] = useState(savedValue);

    useEffect(() => {
        setValue(savedValue);
    }, [savedValue]);

    const handleBlur = () => {
        if (value !== savedValue) {
            onSave(value);
        }
    };

    return (
        <TextField
            id={id}
            label={label}
            value={value}
            disabled={disabled}
            multiline={multiline}
            minRows={multiline ? 2 : undefined}
            fullWidth
            size="small"
            slotProps={{ inputLabel: { shrink: true } }}
            onChange={(event) => setValue(event.target.value)}
            onBlur={handleBlur}
        />
    );
};
